// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__h0SxV","footer":"ModalFilter_footer__3ZJsb"};